export const defaultMapConfig = container => ({
  container,
  center: [87.30588570670284, 22.316610621049918],
  zoom: 14,
  style: "mapbox://styles/mapbox/streets-v11"
});
